// src/bootstrap/sentry.js

import Vue from 'vue'
import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'
import router from '@/router'

const env = process.env.VUE_APP_ENV

// Enable in staging/prod only
if (env === 'staging' || env === 'production') {
  Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    environment: env,

    // Tracing is installed and wired, but disabled via sample rate
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router)
      })
    ],

    tracesSampleRate: 0.0,
    logErrors: true
  })
}
